module.exports = __webpack_public_path__ + "img/banner1.c63bb9b7.jpg";